/**
 * Styles.
 */
import './style.scss';

/**
 * External Dependencies
 */
import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import { Row, Col } from 'reactstrap';
import NavigationTopRight from '../../components/navigation-top-right';

const BatchPaymentRequests = () => {
  const currentUser = useSelector((state) => state.currentUser);

  return (
    <PageWrap>
      <PageTitle
        breadcrumbs={{
          '/': currentUser ? currentUser.name : ' ',
        }}
      >
        <Row className="mb-0">
          <Col md="4">
            <h1>Penagihan Massal</h1>
          </Col>
          <Col md="8" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default BatchPaymentRequests;
